import { EventDetails } from 'sections/Events/components/EventDetails/EventDetails.types';
import { AgendaData } from 'sections/Events/components/AgendaProgram/AgendaProgram.types';

export const eventDetailsData: EventDetails[] = [
  {
    id: 1,
    img: '/images/main/events/intro/4.svg',
    text: '19 July 2022, 15:00 UTC+7 (GMT+7)',
  },
  {
    id: 2,
    img: '/images/main/events/intro/5.svg',
    text: 'Follow our Event online',
    link: 'https://www.youtube.com/watch?v=fRpK-6Ck9AY&ab_channel=DigitalFreightAlliancebyDPWorld',
  },
];

export const agendaData: AgendaData[] = [
  {
    time: '15:00 — 15:05',
    content: [
      {
        text: 'Welcome',
        bold: true,
        inline: true,
      },
      {
        text: ' - Witoon Santibunyarat, President, TIFFA',
        bold: false,
        inline: true,
      },
    ],
  },
  {
    time: '15:05 — 15:10',
    content: [
      {
        text: 'Introduction ',
        bold: true,
        inline: true,
      },
      {
        text: '- Chris Tiffany, Sales Director, DP World',
        bold: false,
        inline: true,
      },
    ],
  },
  {
    time: '15:10 — 15:40',
    content: [
      {
        text: 'Keynote: Digitalization and Future of Freight ',
        bold: true,
        inline: true,
      },
      {
        text: '- Tom James, CEO & CIO, TradeFlow Capital Management',
        bold: false,
        inline: true,
      },
    ],
  },
  {
    time: '15:40 — 16:20',
    content: [
      {
        text: 'Panel Discussion ',
        bold: true,
      },
      {
        text: 'Moderator - ',
        bold: false,
        inline: true,
      },
      {
        text: 'Julian Madsen, General Manager, DP World. ',
        bold: false,
        inline: true,
      },
      {
        text: 'Panelists ',
        bold: false,
        inline: true,
      },
      {
        text: '- Alpesh Sharma, CEO, Laem Chabang International Terminal; Anusorn Lovichit, Managing Director, TIFFA EDI; Vichu Sunthornwiphat, Director, Thai Global Logistics Co., Ltd.',
        bold: false,
        inline: true,
      },
    ],
  },
  {
    time: '16:20 — 16:30',
    content: [
      {
        text: 'Digital Freight Alliance ',
        bold: true,
        inline: true,
      },
      {
        text: '- Ma Czeryna Montefalcon, Account Manager, Digital Freight Alliance',
        bold: false,
        inline: true,
      },
    ],
  },
  {
    time: '16:30 — 16:40',
    content: [
      {
        text: 'Cargoes Flow ',
        bold: true,
        inline: true,
      },
      {
        text: '- Ayaz Maqbool, Head of Digital Products, DP World',
        bold: false,
        inline: true,
      },
    ],
  },
  {
    time: '16:40 — 16:50',
    content: [
      {
        text: 'Cargoes Runner ',
        bold: true,
        inline: true,
      },
      {
        text: '– Gyanesh Singh, Product Sales, DP World',
        bold: false,
        inline: true,
      },
    ],
  },
  {
    time: '16:50 — 17:00',
    content: [
      {
        text: 'Cargoes Finance ',
        bold: true,
        inline: true,
      },
      {
        text: '– Victor Yankovskiy, Senior Manager, DP World',
        bold: false,
        inline: true,
      },
    ],
  },
  {
    time: '17:00 — 20:00',
    content: [
      {
        text: 'Networking ',
        bold: true,
        inline: true,
      },
      {
        text: '– Drinks & Canapes',
        bold: false,
        inline: true,
      },
    ],
  },
];